import { FeaturePanel } from '@engine/features/feature_panel';
import { exists } from '@engine/lib/utility/exists';
import { toggleDisabledAttribute } from '@engine/lib/utility/toggle_disabled_attribute';
var supports_send_notification_control = '.supports-send-notification-control';
var notification_settings_block = '.notification-settings';
var SupportsSendNotificationPanel = new FeaturePanel(supports_send_notification_control, {
  errorMessageTemplate: function errorMessageTemplate(message, errors) {
    return message + '</br>' + errors[1];
  }
});
var NotificationSettingsPanel = new FeaturePanel(notification_settings_block, {
  errorMessageTemplate: function errorMessageTemplate(message, errors) {
    return message + '</br>' + errors[1];
  }
});

function isSendNotificationEnabled() {
  return $('input#supports_send_notification').is(':checked');
}

function notificationSettingsArray() {
  return $(notification_settings_block).find('input[name="notification_settings[]"]:checked').map(function () {
    return this.value;
  }).get();
}

function notificationSignatureAlgorithmValue() {
  return $('select[name="notifications_signature_algorithm"]').val();
}

function notificationSettingsCount() {
  return $(notification_settings_block).find('input[name="notification_settings[]"]').length;
}

function hasAtLeastOneEnabledUrl() {
  var editUrlButtons = $('a[id^="update-notification-url"]');
  var hasEnabledUrl = false;
  var urlData = null;
  $.each(editUrlButtons, function (index, urlButton) {
    urlData = $(urlButton).data('url');

    if (urlData.enabled) {
      hasEnabledUrl = true;
      return;
    }
  });
  return hasEnabledUrl;
}

function toggleSupportedFeatureEditability() {
  var $sendNotificationCheckbox = $('#supports_send_notification');
  var hasTerminalWithEnabledUrl = $sendNotificationCheckbox.data('has-terminal-with-enabled-url');

  if (!exists($sendNotificationCheckbox)) {
    return false;
  }

  if (hasTerminalWithEnabledUrl || hasAtLeastOneEnabledUrl()) {
    toggleDisabledAttribute($sendNotificationCheckbox, false);
  } else if (isSendNotificationEnabled()) {
    toggleDisabledAttribute($sendNotificationCheckbox, true);
    SupportsSendNotificationPanel.update({
      feature: 'supports_send_notification',
      value: false
    });
  } else {
    toggleDisabledAttribute($sendNotificationCheckbox, true);
  }
}

function toggleNotificationSettings() {
  var checkSettings = notificationSettingsArray().length < notificationSettingsCount() / 2;
  $(notification_settings_block).find('input[name="notification_settings[]"]').prop('checked', checkSettings);
}

function updateNotificationSettings() {
  NotificationSettingsPanel.update({
    notification_settings: notificationSettingsArray(),
    notifications_signature_algorithm: notificationSignatureAlgorithmValue()
  });
}

function listenForUpdates() {
  var $sendNotificationCheckbox = $('input#supports_send_notification');

  if (exists($sendNotificationCheckbox)) {
    toggleSupportedFeatureEditability();
    $(document).on('change', '#supports_send_notification', function () {
      SupportsSendNotificationPanel.update({
        feature: 'supports_send_notification',
        value: isSendNotificationEnabled()
      });
    });
  }

  $(document).on('change', '[name="notification_settings[]"]', function () {
    updateNotificationSettings();
  });
  $(document).on('change', '[name="notifications_signature_algorithm"]', function () {
    updateNotificationSettings();
  });
  $(document).on('click', '.notification-settings a.js-select-all', function () {
    toggleNotificationSettings();
    updateNotificationSettings();
  });
}

var NotificationUrl = {
  listenForUpdates: listenForUpdates,
  toggleSupportedFeatureEditability: toggleSupportedFeatureEditability
};
export default NotificationUrl;